import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { Tournament } from '../../models/tournament';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { TournamentService } from '../../services/tournament.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogService } from '../../services/log.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-tournament-card',
  imports: [
    ButtonModule,
    CardModule,
    CommonModule,
    ConfirmPopupModule,
    TooltipModule,
    TranslateModule,
  ],
  providers: [
    ConfirmationService,
  ],
  templateUrl: './tournament-card.component.html',
  styleUrl: './tournament-card.component.scss',
})
export class TournamentCardComponent {
  @Input() tournament: Tournament | undefined;

  @Output() updateEvent = new EventEmitter<void>();

  private readonly destroy$ = inject(DestroyRef);

  constructor(
    public authService: AuthService,
    private confirmationService: ConfirmationService,
    private logService: LogService,
    private router: Router,
    private tournamentService: TournamentService,
    private translate: TranslateService,
  ){}

  public editTournament(): void {
    this.router.navigate(['admin', 'tournaments', 'new', this.tournament?.id]);
  }

  public deleteTournament(event: any): void {
    this.confirmationService.confirm({
      target: event.currentTarget as EventTarget,
      message: this.translate.instant('confirmation.tournament-delete'),
      icon: 'pi pi-info-circle',
      acceptLabel: this.translate.instant('yes'),
      rejectLabel: this.translate.instant('no'),
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        if(!this.tournament) return;
        this.tournamentService.deleteTournament(this.tournament).pipe(takeUntilDestroyed(this.destroy$)).subscribe({
          next: (res) => {
            this.logService.info('[Tournament] - deleteTournament', res, this.translate.instant('success.tournament-delete'));
            this.updateEvent.emit();
          },
          error: (err) => {
            this.logService.error('[Tournament] - deleteTournament', err, this.translate.instant('error.tournament-delete'));
          }
        });
      },
      reject: () => {}
    });
  }

  public archiveTournament(event: any): void {
    this.confirmationService.confirm({
      target: event.currentTarget as EventTarget,
      message: this.translate.instant('confirmation.tournament-archive'),
      icon: 'pi pi-info-circle',
      acceptLabel: this.translate.instant('yes'),
      rejectLabel: this.translate.instant('no'),
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        if(!this.tournament) return;
        this.tournamentService.archiveTournament(this.tournament).pipe(takeUntilDestroyed(this.destroy$)).subscribe({
          next: (res) => {
            this.logService.info('[Tournament] - archiveTournament', res, this.translate.instant('success.tournament-archive'));
            this.updateEvent.emit();
          },
          error: (err) => {
            this.logService.error('[Tournament] - archiveTournament', err, this.translate.instant('error.tournament-archive'));
          }
        });
      },
      reject: () => {}
    });
  }

  public goTournamentDetail(): void {
    this.router.navigate(['admin', 'tournaments', this.tournament?.id]);
  }
}
